"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Italic: function() {
        return Italic;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Italic = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        d: "M19.2 3H10.5C10.2016 3 9.91549 3.11853 9.70451 3.3295C9.49353 3.54048 9.375 3.82663 9.375 4.125C9.375 4.42337 9.49353 4.70952 9.70451 4.9205C9.91549 5.13147 10.2016 5.25 10.5 5.25H13.515L8.373 18.75H4.8C4.50163 18.75 4.21549 18.8685 4.00451 19.0795C3.79353 19.2905 3.675 19.5766 3.675 19.875C3.675 20.1734 3.79353 20.4595 4.00451 20.6705C4.21549 20.8815 4.50163 21 4.8 21H13.5C13.7984 21 14.0845 20.8815 14.2955 20.6705C14.5065 20.4595 14.625 20.1734 14.625 19.875C14.625 19.5766 14.5065 19.2905 14.2955 19.0795C14.0845 18.8685 13.7984 18.75 13.5 18.75H10.782L15.924 5.25H19.2C19.4984 5.25 19.7845 5.13147 19.9955 4.9205C20.2065 4.70952 20.325 4.42337 20.325 4.125C20.325 3.82663 20.2065 3.54048 19.9955 3.3295C19.7845 3.11853 19.4984 3 19.2 3Z",
        fill: "currentColor"
    })
}), "Italic");
const _default = Italic;
